var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgForestBanner(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 128,
    height: 113,
    viewBox: "0 0 128 113",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M43.715.59h43.713v73.677H.001V.59z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M45.03 20H2.077V1.942H45.03V20z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(20 13)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#72B74E",
    d: "M87.43 43.132c0-4.822-3.177-8.862-7.475-10.03-.88-3.471-3.446-6.238-6.743-7.28.475-1.21.742-2.53.742-3.916 0-5.73-4.485-10.378-10.015-10.378-1.786 0-3.458.49-4.907 1.337-1.687-3.003-4.779-5.043-8.345-5.156C49.094 3.542 45.18.59 40.593.59c-3.303 0-6.254 1.533-8.246 3.94a9.636 9.636 0 0 0-2-.206c-4.658 0-8.563 3.301-9.68 7.764a9.707 9.707 0 0 0-3.664-.727C11.471 11.36 6.99 16.01 6.99 21.74c0 .261.017.517.035.772C3.032 23.876.148 27.767.148 32.364c0 5.092 3.538 9.317 8.205 10.202a10.523 10.523 0 0 0-1.32 4.305C2.958 48.187 0 52.127 0 56.78c0 5.734 4.483 10.379 10.015 10.379.229 0 .452-.019.677-.034 1.315 4.147 5.075 7.141 9.513 7.141 3.086 0 5.843-1.447 7.68-3.72.833.19 1.695.297 2.587.297 2.28 0 4.403-.672 6.216-1.818a9.721 9.721 0 0 0 3.174.541c1.865 0 3.61-.54 5.106-1.465a8.098 8.098 0 0 0 5.283 1.964c2.579 0 4.884-1.216 6.41-3.128 1.02.286 2.085.45 3.191.45a11.92 11.92 0 0 0 5.779-1.496c1.772 2.918 4.899 4.864 8.471 4.864 5.533 0 10.018-4.645 10.018-10.379 0-2.979-1.22-5.657-3.16-7.548 3.779-1.486 6.468-5.262 6.468-9.697",
    mask: "url(#b)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(40 81)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#72B74E",
    d: "M43.74 15.539s-1.691-1.209-4.265-1.074c-2.574.134-4.302-.638-5.29-1.278-.986-.637-1.268-2.988-1.2-4.097.073-1.108.247-5.76.247-5.76l.324-.32a8.803 8.803 0 0 1-3.63.777 8.748 8.748 0 0 1-5.406-1.845 10.579 10.579 0 0 1-8.355.897l-.141.374c.14.874.249 4.4.249 4.4s.069 3.157-2.187 4.434c-2.256 1.275-7.827 1.512-7.827 1.512s-3.846.031-4.152 3.088C1.8 19.702 3.949 20 3.949 20h39.51s.987.108 1.482-1.572c.492-1.68-1.2-2.888-1.2-2.888",
    mask: "url(#d)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForestBanner);
export default __webpack_public_path__ + "static/media/ForestBanner.0399ecb6cd53df984dd7df25d94d510f.svg";
export { ForwardRef as ReactComponent };